export default {
    computed: {
        routeBase: function () {
            const path = this.$router.currentRoute.path;
            if (path.includes('engineer')) {
                return 'engineer';
            } else {
                return 'office';
            }
        },

        isOffice: function () {
            return this.routeBase === 'office';
        },

        isEngineer: function () {
            return this.routeBase === 'engineer';
        },
    },
};


// WEBPACK FOOTER //
// ./resources/assets/js/mixins/RouterBaseMixin.js